/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Void1Inputs */

const vi_driverremittance_void1 = /** @type {(inputs: Driverremittance_Void1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huỷ phiếu`)
};

/**

* @param {Driverremittance_Void1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_void1 = /** @type {((inputs?: Driverremittance_Void1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Void1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_void1(inputs)
});
export { driverremittance_void1 as "driverRemittance_void" }